export default class Constants {

    // GAME STATUS
    static GAME_STATUS_NOT_STARTED = 0;
    static GAME_STATUS_PLAYING = 1;
    static GAME_STATUS_PAUSED = 2;
    static GAME_STATUS_ENDED = 3;

    // TURN STATUS
    static TURN_STATUS_START = 0;
    static TURN_STATUS_END = 1;

    // METHODS
    static METHOD_PERCENTAGE = 0;
    static METHOD_POSITION = 1;

    // ENTITIES --> needs to correspond the entitiesRepo array
    static NEW_PILE_INDEX = 0;
    static CANDY_PILE_INDEX = 1;
    static USED_PILE_INDEX = 2;
    static MY_PLAYER_INDEX = 6;
    static COMPUTER_PLAYER_LEFT_INDEX = 5;
    static COMPUTER_PLAYER_TOP_INDEX = 4;
    static COMPUTER_PLAYER_RIGHT_INDEX = 3;

    // TIMER
    static SECONDS_PER_PLAYING_SESSION = 30; // TODO: 30
    static MIN_SECONDS_BEFORE_UNABLE_ACTION_CARDS_EVENTS = 3;
    static MIN_SECONDS_BEFORE_FLASH_TIMER = 5;

    // CARD SIZES
    static CARD_WIDTH_MOBILE = 50;
    static CARD_WIDTH_TABLET = 70;
    static CARD_WIDTH_DESKTOP = 85;

    // BUBBLE SIZES (in vh)
    static BUBBLE_HEIGHT_MOBILE = 15;
    static BUBBLE_HEIGHT_TABLET = 20;
    static BUBBLE_HEIGHT_DESKTOP = 22;

    // PLATE TITLE SIZE
    static TITLE_DIMENSION = 5;

    // PLAYERS
    static POSITION_TOP = 0;
    static POSITION_RIGHT = 1;
    static POSITION_LEFT = 2;
    static POSITION_BOTTOM = 3;

    // TURN SEQUENCE
    static PLAYERS_SEQUENCE = [
        Constants.MY_PLAYER_INDEX,
        Constants.COMPUTER_PLAYER_LEFT_INDEX,
        Constants.COMPUTER_PLAYER_TOP_INDEX,
        Constants.COMPUTER_PLAYER_RIGHT_INDEX
    ];
    static FIRST_ENTITY_TURN = Constants.MY_PLAYER_INDEX;

    // DEALING
    static TOTAL_PLAYERS = 4;
    static TOTAL_CARDS_IN_NEW_PILE = 177; // TODO: 177
    static TOTAL_CARDS_IN_CANDY_PILE = 33; // TODO: 33
    static TOTAL_CARDS_IN_PLAYER_HAND = 6;
    static TOTAL_CARDS_IN_NEW_PILE_AFTER_FIRST_DEAL = Constants.TOTAL_CARDS_IN_NEW_PILE - (Constants.TOTAL_CARDS_IN_PLAYER_HAND * Constants.TOTAL_PLAYERS);
    static TOTAL_CARDS = Constants.TOTAL_CARDS_IN_NEW_PILE + Constants.TOTAL_CARDS_IN_CANDY_PILE;
    static CARDS_TO_DEAL = Constants.TOTAL_CARDS_IN_NEW_PILE - Constants.TOTAL_CARDS_IN_NEW_PILE_AFTER_FIRST_DEAL;
    static MAX_CARD_FOR_EACH_PLAYER = (Constants.TOTAL_CARDS_IN_NEW_PILE - Constants.TOTAL_CARDS_IN_NEW_PILE_AFTER_FIRST_DEAL) / Constants.PLAYERS_SEQUENCE.length;

    // INTERVALS
    static INTERVAL_CARD_MOVE_FULL = 460; // TODO: 460
    static INTERVAL_CARD_MOVE = 100;
    static INTERVAL_WAIT = 50;
    static INTERVAL_AFTER_COMPUTER_PLAY = 1000;
    static INTERVAL_AFTER_MYPLAYER_PLAY = 2000;
    static INTERVAL_BEFORE_REMOVE_POPUP = 3000;
    static INTERVAL_AFTER_CHOOSE_CARD_EVENT = 100;
    static INTERVAL_FOR_COMPUTER_PLAYER_STOP_CARD = 1000;

    // CARDS DEGREE
    static CARD_DEG_VERTICAL_TOP = 0;
    static CARD_DEG_VERTICAL_BOTTOM = 180;
    static CARD_DEG_HORIZONTAL_RIGHT = 90;
    static CARD_DEG_HORIZONTAL_LEFT = 270;
    static FAN_ANGLE_MAX_RANGE = 120;

    // USER ENENTS
    static USER_EVENT_CHOSE_A_CARD_FROM_NEW_PILE = 0;
    static USER_EVENT_CHOSE_A_CARD_FROM_MY_CARDS = 1;
    static USER_EVENT_CLICKED_ON_POPUP = 1;

    // ELEMENTS --> needs to correspond the elementHandler array
    static ELEMENT_NEW_PILE_PICK_A_CARD = 0;
    static ELEMENT_MY_PLAYER_THROW_A_CARD = 1;
    static ELEMENT_CARD_POPUP = 2;
    static ELEMENT_MY_PLAYER_THROW_ONION_GARLIC_CARD = 3;
    static ELEMENT_MY_PLAYER_THROW_CABBAGE_BROCCOLI_CARD = 4;
    static ELEMENT_MY_PLAYER_SWITCH_A_CARD = 5;
    static ELEMENT_ENEMIES_SWITCH_A_CARD = 6;
    static ELEMENT_CARD_INSTRUCTIONS = 7;
    static ELEMENT_MY_PLAYER_THROW_SHUM_BAZAL = 8;
    static ELEMENT_MY_PLAYER_PLAYING_PLATE = 9;
    static ELEMENT_LEFT_PLAYER_PLAYING_PLATE = 10;
    static ELEMENT_TOP_PLAYER_PLAYING_PLATE = 11;
    static ELEMENT_RIGHT_PLAYER_PLAYING_PLATE = 12;
    static ELEMENT_MY_PLAYER_TITLE_PLATE = 13;
    static ELEMENT_TOP_PLAYER_TITLE_PLATE = 14;
    static ELEMENT_RIGHT_PLAYER_TITLE_PLATE = 15;
    static ELEMENT_LEFT_PLAYER_TITLE_PLATE = 16;
    static ELEMENT_GAME_TIMER = 17;
    static ELEMENT_PAUSE_BUTTON = 18;
    static ELEMENT_MUTE_BUTTON = 19;

    static BUBBLE_ELEMENTS=[
        Constants.ELEMENT_NEW_PILE_PICK_A_CARD,
        Constants.ELEMENT_MY_PLAYER_THROW_A_CARD,
        Constants.ELEMENT_MY_PLAYER_THROW_ONION_GARLIC_CARD,
        Constants.ELEMENT_MY_PLAYER_THROW_CABBAGE_BROCCOLI_CARD,
        Constants.ELEMENT_MY_PLAYER_SWITCH_A_CARD,
        Constants.ELEMENT_ENEMIES_SWITCH_A_CARD
    ]

    // FLAGS
    static FLAGS_SINGLE_TIME_USE = true;
    static FLAGS_MULTIPLE_TIME_USE = false;
    static FLAGS_REPLACE_METHOD = true;

    // SOUNDS
    static SOUND_CHAMPIONS_PAGE = "champions-page";
    static SOUND_HOME_PAGE = "home-page";
    static SOUND_DEMO_CARD = "demo-card";
    static SOUND_JOKER_CARD = "joker-card";
    static SOUND_VIRUS_CARD = "virus-card";
    static SOUND_STOP_CARD = "stop-card";
    static SOUND_SWITCH_FRIEND_CARD = "switch-friend-card";
    static SOUND_SWITCH_STACK_CARD = "switch-stack-card";
    static SOUND_SURPRISE_MEAL_CARD = "surprise-meal-card";
    static SOUND_BIRTHDAY_ATTACK_CARD = "birthday-attack-card";
    static SOUND_TRIP_ATTACK_CARD = "trip-attack-card";
    static SOUND_GRANDMA_ATTACK_CARD = "grandma-attack-card";
    static SOUND_PROTECTION_CARD = "protection-card";
    static SOUND_BACKGROUND = "background"; //
    static SOUND_BUBBLE = "bubble";
    static SOUND_BUTTON = "button";
    static SOUND_CARD_MOVE = "move";
    static SOUND_TICK = "tick";
    static SOUND_WINNING = "winning";
    static SOUND_LOSING = "losing";

    // SCORING
    static SCORE_SET_CARD = 10
    static SCORE_PROTECTION_CARD = 5;
    static SCORE_WINING_BONUS = 40;

    // PLAYR STATUS
    static PLAYR_STATUS_WINNING = 0;
    static PLAYR_STATUS_LOSING = 1;

    // CARD EVENTS
    static CARD_EVENT_ON_AFTER_CARD_THROWN_FROM_PLAYER_TO_USED_PILE = 0;
    static CARD_EVENT_ON_AFTER_PLAYER_GET_CARD_FROM_NEW_PILE_OR_USED_PILE = 1;
}
